import { Component, forwardRef, Input } from '@angular/core';
import {
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import {
  CvaFormGroupComponent,
  ResetOptions
} from '@liberty-financial/agp-shared';
import { GuidUtil } from '@liberty-financial/ng-core';
import * as _ from 'lodash';

type YesOrNoField = 'Yes' | 'No';
@Component({
  selector: 'spark-shared-yes-or-no-field',
  templateUrl: './yes-or-no.component.html',
  styleUrls: ['./yes-or-no.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => YesOrNoFieldComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => YesOrNoFieldComponent),
      multi: true
    }
  ]
})
export class YesOrNoFieldComponent extends CvaFormGroupComponent<
  boolean | null,
  YesOrNoField | null
> {
  @Input() identifier = GuidUtil.generate();
  @Input() label!: string;
  @Input() isRequired = false;
  @Input() showHighlight = false;
  @Input() wrapLabelText = true;

  form = new FormControl<YesOrNoField | null>(null);
  formGroup = new FormGroup({
    field: this.form
  });

  protected reset(opts?: ResetOptions | undefined): void {
    this.form.reset(undefined, opts);
  }

  transformToModel = (value: YesOrNoField | null): boolean | null =>
    value === 'Yes' ? true : value === 'No' ? false : null;
  transformToForm = (value: boolean | null): YesOrNoField | null =>
    _.isBoolean(value) ? (value ? 'Yes' : 'No') : null;
}
